<template>
  <div>
    <a  href='#' @click="goTo({path: '/mf/home' })" class='back-button'> <font-awesome-icon title='Voltar' icon="fa-arrow-left" /> </a>
    <h2>Nossas Campanhas</h2><br>
    <div class="et_pb_row et_pb_row_2">
      <div class="et_pb_column et_pb_column_1_2 et_pb_column_2  et_pb_css_mix_blend_mode_passthrough">
        <div class="et_pb_module et_pb_image et_pb_image_0">
          <a href="https://polen.com.br/fundacaodocancer" target="_blank"><span class="et_pb_image_wrap has-box-shadow-overlay">
          <div class="box-shadow-overlay"></div>
          <img src="https://www.cancer.org.br/wp-content/uploads/2020/01/area-doador-o-polenweb.jpg" alt="" title=""></span></a>
        </div>
      </div>
      <div class="et_pb_column et_pb_column_1_2 et_pb_column_3  et_pb_css_mix_blend_mode_passthrough et-last-child">
        <div class="et_pb_module et_pb_image et_pb_image_1">
            <a href="https://www.presentesolidario.com.br/fundacao-do-cancer" target="_blank">
            <span class="et_pb_image_wrap has-box-shadow-overlay">
              <div class="box-shadow-overlay"></div>
              <img src="https://www.cancer.org.br/wp-content/uploads/2020/01/area-doador-presente-solidarioweb.jpg" alt="" title="">
              </span>
            </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Campaigns',
  methods: {
    goTo (params) {
      this.$router.push({ path: params.path });
    }
  }
};

</script>
